import React from "react";
import {
  Card as MUICard,
  CardContent,
  Typography,
  IconButton,
  Grid,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import "../assets/css/Card.css";

const Card = ({ title, value, icon, info, color }) => {
  let iconColor = ""; // Default icon color
  if (color === "1") {
    iconColor = "#00BB9F"; // Color for InboxIcon
  } else if (color === "2") {
    iconColor = "#6CD8BF"; // Color for OutboxIcon
  } else if (color === "3") {
    iconColor = "#B0EE93"; // Color for TrendingUpIcon
  }

  return (
    <MUICard className="metric-card">
      <CardContent className="card-item">
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5" className="value" sx={{ my: 2 }}>
              {value}
            </Typography>
            <Typography variant="subtitle1" className="title">
              {title}
            </Typography>
          </Grid>
          <div style={{ display: "flex", alignItems: "center" }}>
            {icon && (
              <IconButton
                style={{ backgroundColor: iconColor, color: "white" }}
              >
                {React.cloneElement(icon, { style: { fontSize: 24 } })}
              </IconButton>
            )}
            {info && (
              <IconButton>
                <InfoIcon />
              </IconButton>
            )}
          </div>
        </Grid>
      </CardContent>
    </MUICard>
  );
};

export default Card;
